const SHOWCASE_DE = {
  title: 'Showcase',
  subtitle:
    'Auf dieser Seite finden Sie einen Vergleich der Kandidaten nach den wichtigsten Anforderungen',
  mobileView:
    'Wir haben diese Erfahrung auf dem Desktop optimiert, um die Daten und Kandidatenbewertungen besser nutzbar zu machen.',
  lastViewUpdate:
    'Gesehen und gespeichert am {{ date, datetime(format: dd/MM/yyyy) }} um {{ date, datetime(format: HH:mm) }} Uhr',
  yes: 'Ja',
  no: 'Nein',
  bubbleText:
    'Auf dieser Seite können Sie die Eigenschaften der vorgestellten Profile vergleichen. Ein weiteres Mittel, um Ihnen die Wahl des richtigen Profils zu erleichtern.',
  emptyCandidateList:
    'Von hier aus kannst du die <strong>Hauptmerkmale</strong> der <strong>Kandidaten</strong> vergleichen, die wir dir vorgestellt haben.',
  tableRows: {
    photo: 'Foto',
    age: 'Alter',
    seniority: 'Seniorität',
    location: 'Standort',
    must_have: 'Must have',
    nice_to_have: 'Nice to have',
    current_global_compensation: 'Aktuelles Vergütungs-paket',
    desired_global_compensation: 'Gewünschtes Vergütungs-paket',
    non_compete_agreement: 'Wettbewerbsverbote',
    notice_period: 'Kündigungs-frist',
    company: 'Unternehmen',
    other_selections: 'Andere<1></1>Auswahl-verfahren',
    motivation: 'Motivation',
    summary: 'Zusammen-fassung',
  },
  filters: {
    restoreView: 'Ansicht wiederherstellen',
    interestedBut: '<1>Interessiert, aber</1> anzeigen',
    out: '<1>Eliminierte Kandidaten</1> anzeigen',
  },
  benefitsCategories: {
    car: 'Firmenwagen',
    food: 'Essensgutscheine oder Kantine',
    training: 'Schulung',
    welfare: 'Sozialleistungen',
    insurance: 'Versicherung',
    devices: 'Geräte',
    remote_working: 'Homeoffice oder flexible Arbeitszeiten',
  },
  company: {
    freelance: 'Freiberufler',
  },
  chip: {
    interestedBut: 'Interested but',
    out: 'Out',
  },
  location: {
    locationAndDistance: '<strong>{{ location }}</strong>',
    locationAndDistance_withDistance:
      '<strong>{{ location }}</strong> ({{ distance }}km)',
  },
  summary: {
    readmore: 'Mehr erfahren',
    hide: 'Verbergen',
  },
  concernsCategories: {
    brand: 'Brand',
    role: 'Rolle',
    compensation: 'Gehalt',
    location: 'Standort',
  },
  motivationToChangeValues: {
    low: 'Low',
    high: 'High',
    medium: 'Medium',
  },
  drivingTime: {
    hours: '<b>{{ hours }}</b> St.',
    minutes: '<b>{{ minutes }}</b> Min.',
  },
  otherSelections: {
    inProgress: '{{ count }} im Prozess',
    notSpecified: 'Andere Bewerbungsprozesse, nicht spezifiziert',
  },
  currentGlobalCompensation: {
    payTransparencyDisclaimer:
      'Die Nachfrage nach aktuellen oder früheren Vergütungsangaben ist seit dem 7. Juli 2026 gesetzlich eingeschränkt (Richtlinie (EU) 2023/970).<br/><br/>Konzentrieren Sie sich stattdessen auf die Gehaltsvorstellungen.',
  },
};

export default SHOWCASE_DE;
